angular.module('rjmNg.api').factory 'Billing', [
  "$resource"
  "$cacheFactory"
  "serviceUrl"
  (
    $resource
    $cacheFactory
    serviceUrl
  ) ->

    actionUrls =
      tiers: serviceUrl '/v3/billing/tiers'
      generateToken: serviceUrl '/v3/clients/:clientId/billing/token'
    #  paymentMethods: serviceUrl '/v3/clients/:clientId/billing/payment-methods'
      status: serviceUrl '/v3/clients/:clientId/billing/status'
      subscriptionStatus: serviceUrl '/v3/clients/:clientId/billing/subscription/status'

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      getTiers: angular.extend {}, defaultParams,
        method: 'GET'
        url: actionUrls.tiers
        isArray: true
      generateClientToken: angular.extend {}, defaultParams,
        method: 'POST'
        url: actionUrls.generateToken
      # createPaymentMethod: angular.extend {}, defaultParams,
      #   method: 'POST'
      #   url: actionUrls.paymentMethods
      # getPaymentMethods: angular.extend {}, defaultParams,
      #   method: 'GET'
      #   url: actionUrls.paymentMethods
      #   isArray: true
      getStatus: angular.extend {}, defaultParams,
        method: 'GET'
        cache: $cacheFactory.get('Billing') or $cacheFactory('Billing')
        url: actionUrls.status
      getSubscriptionStatus: angular.extend {}, defaultParams,
        method: 'GET'
        url: actionUrls.subscriptionStatus


    billing = $resource "", {}, actions

    clearCache = () ->
      $cacheFactory.get('Billing')?.removeAll()

    Billing =
      getTiers: () ->
        billing.getTiers().$promise

      generateClientToken: (clientId) ->
        billing.generateClientToken({clientId}, {}).$promise

      # createPaymentMethod: (clientId, nonce) ->
      #   clearCache()
      #   billing.createPaymentMethod({clientId}, {nonce}).$promise

      # getPaymentMethods: (clientId) ->
      #   billing.getPaymentMethods({clientId}).$promise

      getStatus: (clientId) ->
        billing.getStatus({clientId}).$promise

      getSubscriptionStatus: (clientId) ->
        billing.getSubscriptionStatus({clientId}).$promise

    Billing
]
